import { Col, InputRef, Row, Table } from "antd";
import { useForm } from "antd/lib/form/Form";
import { get } from "lodash";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import {
  checkDuplicatiedId,
  checkPhoneAuth,
  register,
  sendPhoneNumber,
} from "../../../../apis/Register/apis";
import { RepairshopRegisterRequestBody } from "../../../../apis/Register/apis/types";
import {
  ReactComponent as CautionBlank,
  ReactComponent as Number1,
  ReactComponent as Number2,
  ReactComponent as Number3,
} from "../../../../assets/icons/AlarmFill.svg";
import Button from "../../../../components/atoms/Button";
import Buttons from "../../../../components/atoms/Buttons";
import CheckBox from "../../../../components/atoms/Checkbox";
import Explain from "../../../../components/atoms/Explain";
import FormLabel from "../../../../components/atoms/FormLabel";
import SelectGroup from "../../../../components/atoms/Inputs/SelectGroup";
import TextInputs from "../../../../components/atoms/Inputs/TextInputs";
import RadioGroup from "../../../../components/atoms/RadioGroup";
import TextArea from "../../../../components/atoms/TextArea";
import {
  ALERT_MESSAGE,
  MIN_MORNITOR_WIDTH,
  SUCCESS_MESSAGE,
} from "../../../../components/constants";
import ImageTextUploader from "../../../../components/molecures/ImageTextUploader";
import PreviewUploader from "../../../../components/molecures/PreviewUploader";
import SearchAddress from "../../../../components/molecures/SearchAddressModal";
import { CustomForm } from "../../../../components/organisms/Form/index.styled";
import { UserInfoServiceForm } from "../../../../components/organisms/UserInfo/Service";
import useCounter from "../../../../hooks/useCounter";
import useModals from "../../../../hooks/useModals";
import { Media } from "../../../../model/Media";
import { PATH } from "../../../../routes/constants/path";
import sharedConstants from "../../../../shared/constants";
import { RepairShopMediaType } from "../../../../shared/enums";
import { yesOrNoArray } from "../../../../shared/options";
import {
  alertError,
  alertSuccess,
  validateEmail,
  validatePass,
  validatePhone,
} from "../../../../shared/utils";
import { theme } from "../../../../theme";
import {
  CountryType,
  NumberArray,
  PLACEHOLDER,
  SpecialCar,
  colFullProps,
  colHalfProps,
  initialDataForm,
  initialDivRef,
  initialInputRef,
  initialValidation,
  marketingPossibleArray,
} from "../../constants";
import AuthTokenInput from "../AuthTokenInput";
import CustomInputNumber from "../CustomInputNumber";
import { DataForm, ValidationStatus } from "../types";

interface RefInputItem {
  repairShopAId: InputRef | null;
  password: InputRef | null;
  rePass: InputRef | null;

  displayName: InputRef | null;
  managerName: InputRef | null;
  managerPhone: InputRef | null;
  managerEmail: InputRef | null;
  tel: InputRef | null;
  street: InputRef | null;
  detail: InputRef | null;
  businessMediaId: InputRef | null;
  repairShopMediaIds: InputRef | null;

  [index: string]: InputRef | null;
}
interface RefDivItem {
  businessMediaId: HTMLDivElement | null;
  repairShopMediaIds: HTMLDivElement | null;

  [index: string]: HTMLDivElement | null;
}

const RegisterForm: React.FC = () => {
  const nav = useNavigate();
  const location = useLocation();

  const [form] = useForm();

  const sendRegisterMutation = useMutation(register, {
    onSuccess: () => {
      closeModal();
      openAlertModal({
        contents: (
          <div>
            제휴 신청이 완료되었습니다.
            <br />
            담당자가 승인 혹은 반려 안내 드릴 예정입니다.
            <br />
            수정을 원하시거나 진행 상태가 궁금하시면 입력하신 ID와
            <br />
            비밀번호로 로그인해주세요.
          </div>
        ),
        title: "제휴 신청 완료",
      });

      const sch = location.search;
      const params = new URLSearchParams(sch);
      const keyword = params.get("isApp");
      if (keyword === "true") nav(PATH.APP_CONFIRM);
      else nav(PATH.HOME);
    },
    onError: (err) => {
      alertError(get(err, "message"));
    },
  });
  const sendPhoneAuthMutation = useMutation(sendPhoneNumber, {
    onSuccess: (res) => {
      startCounter();
      setDataForm({ ...dataForm, authTokenId: res.authTokenId });
      alertSuccess("문자가 전송되었습니다.인증 코드를 확인해주세요.");
    },
    onError: () => {},
  });
  const checkPhoneAuthMutation = useMutation(checkPhoneAuth, {
    onSuccess: (res) => {
      setAuthPass(true);
      stopCounter();
      setDataForm({ ...dataForm, accessToken: res.accessToken });
      setStatus({
        ...status,
        auth: {
          status: "success",
          explain: "인증번호가 확인되었습니다.",
        },
      });
    },
    onError: () => {
      setStatus({
        ...status,
        auth: {
          status: "error",
          explain: ALERT_MESSAGE.WRONG_AUTH,
        },
      });
    },
  });
  const sendCheckDuplicateMutation = useMutation(checkDuplicatiedId, {
    onSuccess: () => {
      setStatus({
        ...status,
        repairShopAId: {
          status: "success",
          explain: SUCCESS_MESSAGE.NO_DUPLIACTED_ID,
        },
      });
      setDuplicationCheck(true);
    },
    onError: () => {
      setStatus({
        ...status,
        repairShopAId: {
          status: "error",
          explain: ALERT_MESSAGE.DUPLICATED_ID,
        },
      });
      inputRef.current.repairShopAId?.focus();
    },
  });

  const {
    stopCounter,
    resetCounter,
    startCounter,
    counter,
    minuteText,
    secondText,
  } = useCounter(180);
  const inputRef = useRef<RefInputItem>(initialInputRef);
  const divRef = useRef<RefDivItem>(initialDivRef);
  const {
    openModal,
    openAlertModal,
    openConfirmModal,
    closeModal,
    getLoading,
  } = useModals();
  const [dataForm, setDataForm] = useState<DataForm>(initialDataForm);
  const [isDuplicationChecked, setDuplicationCheck] = useState(false);
  const [isSendPhone, setSendPhone] = useState(false);
  const [isAuthPass, setAuthPass] = useState(false);
  const [authCode, setAuthcode] = useState("");
  const [isLoading, setLoading] = useState(false);

  const initialStatus: { [index: string]: ValidationStatus } = {};
  Object.keys(dataForm).map((value) => {
    initialStatus[value] = initialValidation;
    return 0;
  });

  const [status, setStatus] = useState<{ [index: string]: ValidationStatus }>({
    ...initialStatus,
    rePass: initialValidation,
  });

  const onCheckMarketing = () => {
    setDataForm({
      ...dataForm,
      marketingEmailReceivable: !dataForm.marketingEmailReceivable,
      marketingMessageReceivable: !dataForm.marketingMessageReceivable,
      marketingPushReceivable: !dataForm.marketingPushReceivable,
    });
  };
  const onSendCheckDuplication = () => {
    if (dataForm.repairShopAId === "") {
      setStatus({
        ...status,
        repairShopAId: { status: "error", explain: PLACEHOLDER.aId },
      });
    } else {
      sendCheckDuplicateMutation.mutate({
        repairShopAId: dataForm.repairShopAId,
      });
    }
  };

  /**
   * form finish hadler
   * @TODO 다른 정보도 form처리하기
   * @param values
   */
  const handleFinish = (values: any) => {
    setDataForm((prev) => ({ ...prev, ...values, truckAcceptable: true }));

    /**
     * 기존 체크
     */
    validateAndSendData();
  };

  useEffect(() => {
    const passMessages = validatePass(dataForm.password);

    setStatus({
      ...status,
      password: {
        status:
          dataForm.password.length === 0
            ? undefined
            : passMessages.length === 0
            ? "success"
            : "error",
        explain:
          dataForm.password.length === 0
            ? undefined
            : passMessages.length === 0
            ? "올바른 비밀번호 입니다."
            : passMessages.join(" "),
      },
    });
  }, [dataForm.password, dataForm.rePass]);

  /**
   * @history 필수 풀었다가 다시 추가
   */
  const validateAndSendData = () => {
    const newStatus = {
      ...status,
    };
    const requiredList = Object.keys(dataForm);

    for (let i = 0; i < requiredList.length; i += 1) {
      if (
        requiredList[i] !== "optionalTermsIds" &&
        requiredList[i] !== "waTypes" &&
        requiredList[i] !== "repairShopName" &&
        requiredList[i] !== "repairShopMediaIds" &&
        requiredList[i] !== "subPhone1" &&
        requiredList[i] !== "subPhone2" &&
        requiredList[i] !== "subManagerPhoneList"
        // requiredList[i] !== "businessRegistrationNumber" &&
        // requiredList[i] !== "businessMediaId" &&
        // requiredList[i] !== "frontMedia" &&
        // requiredList[i] !== "inMedia" &&
        // requiredList[i] !== "allMedia"
      )
        if (
          dataForm[requiredList[i]] === "" ||
          dataForm[requiredList[i]] === undefined ||
          dataForm[requiredList[i]].length === 0 ||
          dataForm[requiredList[i]] === -1
        )
          newStatus[requiredList[i]] = {
            status: "error",
            explain: "필수 값입니다.",
          };
      if (requiredList[i] === "password") {
        if (validatePass(dataForm.password).length > 0) {
          newStatus[requiredList[i]] = {
            status: "error",
            explain: validatePass(dataForm.password).join(" "),
          };
        }
      }

      switch (requiredList[i]) {
        case "repairShopAId":
          if (requiredList[i] === "repairShopAId") {
            if (
              dataForm[requiredList[i]].length > 0 &&
              isDuplicationChecked === false
            )
              newStatus[requiredList[i]] = {
                status: "error",
                explain: ALERT_MESSAGE.NO_DUPLIACTE_CHECK,
              };
          }
          break;
        case "detail":
          if (
            dataForm[requiredList[i]] === "" ||
            dataForm[requiredList[i]] === undefined ||
            dataForm[requiredList[i]].length === 0 ||
            dataForm[requiredList[i]] === -1
          )
            newStatus.street = {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };
          break;

        default:
          break;
      }
      if (isAuthPass === false) {
        newStatus.managerPhone = {
          status: "error",
          explain: ALERT_MESSAGE.NO_PHONE_AUTH,
        };
      }
    }

    setStatus(newStatus);
    if (validateAndScroll(newStatus) === true) {
      const newSubManagerPhoneList = [];
      if (dataForm.subPhone1) newSubManagerPhoneList.push(dataForm.subPhone1);
      if (dataForm.subPhone2) newSubManagerPhoneList.push(dataForm.subPhone2);

      /**
       * @author carol
       * @history 매장사진필수 제거에 맞춰 동적처리
       */
      const types: { [k: string]: RepairShopMediaType } = {
        allMedia: RepairShopMediaType.ALL,
        frontMedia: RepairShopMediaType.FRONT,
        inMedia: RepairShopMediaType.IN,
      };

      const repairShopMedias = Object.keys(types)
        .filter((key) => !!dataForm[key])
        .map((key) => ({
          repairShopMediaId: dataForm[key]?.id,
          type: types[key],
        }));

      const requestBody: RepairshopRegisterRequestBody = {
        ...dataForm,
        subManagerPhoneList: newSubManagerPhoneList,
        repairShopMedias: [...repairShopMedias],
        domesticLightRepairHandleable: dataForm.lightRepairTypes.includes(
          CountryType.Domestic
        ),

        domesticEngineOilExchangeable: dataForm.engineOilTypes.includes(
          CountryType.Domestic
        ),
        domesticBatteryExchangeable: dataForm.batteryTypes.includes(
          CountryType.Domestic
        ),
        domesticWAHandleable: dataForm.waTypes.includes(CountryType.Domestic),
        foreignLightRepairHandleable: dataForm.lightRepairTypes.includes(
          CountryType.Foreign
        ),
        foreignEngineOilExchangeable: dataForm.engineOilTypes.includes(
          CountryType.Foreign
        ),
        foreignBatteryExchangeable: dataForm.batteryTypes.includes(
          CountryType.Foreign
        ),
        foreignWAHandleable: dataForm.waTypes.includes(CountryType.Foreign),
        bongoAcceptable: dataForm.speciaCars.includes(SpecialCar.BONGO),
        porterHighTopAcceptable: dataForm.speciaCars.includes(
          SpecialCar.PORTER_HIGH_TOP
        ),
        repairShopName:
          dataForm.repairShopName && dataForm.repairShopName.length > 0
            ? dataForm.repairShopName
            : undefined,
        porterLowTopAcceptable: dataForm.speciaCars.includes(SpecialCar.BONGO),
        repairShopOption: form.getFieldValue("repairShopOption"),
      };

      openConfirmModal({
        contents: "제휴 신청을 하시겠습니까?",
        title: "제휴 신청",
        onOk: () => sendRegisterMutation.mutate({ ...requestBody }),
      });
    }
  };
  const debouncedPhoneSend = () => {
    setAuthPass(false);
    setLoading(true);
    setSendPhone(true);
    resetCounter();
    sendPhoneAuthMutation.mutate({
      key: dataForm.managerPhone,
    });
  };
  const debouncedPhoneResend = () => {
    setAuthPass(false);
    setSendPhone(true);
    setLoading(true);
    resetCounter();
    if (status.managerPhone.status !== "error") {
      setDataForm({ ...dataForm, authTokenId: "" });
      setStatus({ ...status, auth: initialValidation });
      sendPhoneAuthMutation.mutate({
        key: dataForm.managerPhone,
      });
    }
  };
  const validateAndScroll = (status: { [index: string]: ValidationStatus }) => {
    const requiredList = Object.keys(dataForm);
    const divRefKeys = Object.keys(initialDivRef);
    const inputRefKeys = Object.keys(initialInputRef);
    for (let i = 0; i < requiredList.length; i += 1) {
      if (
        status[requiredList[i]] &&
        status[requiredList[i]].status === "error"
      ) {
        if (divRefKeys.includes(requiredList[i])) {
          return divRef.current[requiredList[i]]?.scrollIntoView();
        }
        if (inputRefKeys.includes(requiredList[i])) {
          return inputRef.current[requiredList[i]]?.focus();
        }
      }
    }

    if (isAuthPass === false) return inputRef.current.managerPhone?.focus();
    if (isDuplicationChecked === false)
      return inputRef.current.repairShopAId?.focus();
    return true;
  };

  useEffect(() => {
    if (isLoading)
      setTimeout(() => {
        if (!sendPhoneAuthMutation?.isLoading) setLoading(false);
      }, 1000);
  }, [isLoading, sendPhoneAuthMutation.isLoading]);

  return (
    <FormContatiner>
      <FormWrapper>
        <Row gutter={[60, 60]} justify="center">
          <FullCol>
            <RegisterTitle>기본정보</RegisterTitle>
          </FullCol>
          <FullCol>
            <Row>
              <HalfCol>
                <FormLabel>아이디</FormLabel>
                <TextInputs
                  ref={(ref) => {
                    inputRef.current.repairShopAId = ref;
                  }}
                  additionalBtn={
                    <Button
                      size="large"
                      ghost
                      onClick={
                        status.repairShopAId.status === "error"
                          ? undefined
                          : onSendCheckDuplication
                      }
                    >
                      중복확인
                    </Button>
                  }
                  showCount={false}
                  isNotBordered
                  onPressEnter={
                    status.repairShopAId.status === "error"
                      ? undefined
                      : onSendCheckDuplication
                  }
                  status={status.repairShopAId.status}
                  explain={status.repairShopAId.explain}
                  onChange={(e) => {
                    setStatus({ ...status, repairShopAId: initialValidation });

                    setDataForm({ ...dataForm, repairShopAId: e });

                    if (!e.match(/^[a-zA-Z0-9]*$/))
                      setStatus({
                        ...status,
                        repairShopAId: {
                          status: "error",
                          explain: "아이디는 영어 + 숫자로 입력해주세요",
                        },
                      });
                  }}
                  placeholder={PLACEHOLDER.aId}
                  value={dataForm.repairShopAId}
                  maxLength={16}
                />
              </HalfCol>
              <HalfCol />
            </Row>
          </FullCol>

          <HalfCol>
            <FormLabel>비밀번호</FormLabel>
            <TextInputs
              isNotBordered
              ref={(ref) => {
                inputRef.current.password = ref;
              }}
              isPassword
              placeholder={PLACEHOLDER.pass}
              status={status.password.status}
              explain={status.password.explain}
              onBlur={(e) => {
                setStatus({
                  ...status,

                  rePass: {
                    status:
                      e.length > 0
                        ? e === dataForm.rePass
                          ? "success"
                          : "error"
                        : undefined,
                    explain:
                      e.length > 0
                        ? e === dataForm.rePass
                          ? SUCCESS_MESSAGE.VALID_REPASS
                          : ALERT_MESSAGE.INVALID_REPASS
                        : undefined,
                  },
                });
              }}
              onChange={(e) => {
                setStatus({
                  ...status,
                  password: initialValidation,
                  rePass: {
                    status:
                      e.length > 0
                        ? e === dataForm.rePass
                          ? "success"
                          : "error"
                        : undefined,
                    explain:
                      e.length > 0
                        ? e === dataForm.rePass
                          ? SUCCESS_MESSAGE.VALID_REPASS
                          : ALERT_MESSAGE.INVALID_REPASS
                        : undefined,
                  },
                });

                setDataForm({ ...dataForm, password: e });
              }}
              maxLength={100}
              value={dataForm.password}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>비밀번호 확인</FormLabel>
            <TextInputs
              isNotBordered
              isPassword
              ref={(ref) => {
                inputRef.current.rePass = ref;
              }}
              isNotShowPassword
              status={status.rePass.status}
              explain={status.rePass.explain}
              placeholder={PLACEHOLDER.rePass}
              onBlur={(e) => {
                setStatus({
                  ...status,

                  rePass: {
                    status:
                      e.length > 0
                        ? e === dataForm.password
                          ? "success"
                          : "error"
                        : undefined,
                    explain:
                      e.length > 0
                        ? e === dataForm.password
                          ? SUCCESS_MESSAGE.VALID_REPASS
                          : ALERT_MESSAGE.INVALID_REPASS
                        : undefined,
                  },
                });
              }}
              onChange={(e) => {
                setDataForm({ ...dataForm, rePass: e });
                setStatus({
                  ...status,
                  rePass: {
                    status:
                      e.length > 0
                        ? e === dataForm.password
                          ? "success"
                          : "error"
                        : undefined,
                    explain:
                      e.length > 0
                        ? e === dataForm.password
                          ? SUCCESS_MESSAGE.VALID_REPASS
                          : ALERT_MESSAGE.INVALID_REPASS
                        : undefined,
                  },
                });
              }}
              maxLength={100}
              value={dataForm.rePass}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>상호명</FormLabel>
            <TextInputs
              isNotBordered
              ref={(ref) => {
                inputRef.current.displayName = ref;
              }}
              status={status.displayName.status}
              explain={status.displayName.explain}
              placeholder={PLACEHOLDER.diplayName}
              onChange={(e) => {
                setStatus({
                  ...status,
                  displayName: initialValidation,
                });
                setDataForm({ ...dataForm, displayName: e });
              }}
              maxLength={100}
              value={dataForm.displayName}
            />
          </HalfCol>
          <InputWrapper {...colHalfProps}>
            <FormLabel>담당자 성함</FormLabel>
            <TextInputs
              isNotBordered
              ref={(ref) => {
                inputRef.current.managerName = ref;
              }}
              status={status.managerName.status}
              explain={status.managerName.explain}
              placeholder={PLACEHOLDER.manageName}
              onChange={(e) => {
                setStatus({
                  ...status,
                  managerName: initialValidation,
                });
                setDataForm({ ...dataForm, managerName: e });
              }}
              maxLength={100}
              value={dataForm.managerName}
            />
          </InputWrapper>
          <HalfCol>
            <FormLabel>휴대폰번호</FormLabel>

            <TextInputs
              onPressEnter={
                dataForm.managerPhone.trim().length === 0 ||
                !validatePhone(dataForm.managerPhone)
                  ? () => {
                      setStatus({
                        ...status,
                        managerPhone: {
                          status: "error",
                          explain: ALERT_MESSAGE.WRONG_PHONE,
                        },
                      });
                    }
                  : !isLoading
                  ? debouncedPhoneResend
                  : undefined
              }
              isNotBordered
              showCount={false}
              ref={(ref) => {
                inputRef.current.managerPhone = ref;
              }}
              value={dataForm.managerPhone}
              placeholder={PLACEHOLDER.phone}
              status={status.managerPhone.status}
              explain={status.managerPhone.explain}
              maxLength={20}
              additionalBtn={
                isSendPhone ? (
                  <Button
                    size="large"
                    type="primary"
                    ghost
                    onClick={
                      dataForm.managerPhone.trim().length === 0 ||
                      !validatePhone(dataForm.managerPhone)
                        ? () => {
                            setStatus({
                              ...status,
                              managerPhone: {
                                status: "error",
                                explain: ALERT_MESSAGE.WRONG_PHONE,
                              },
                            });
                          }
                        : debouncedPhoneResend
                    }
                    disabled={isAuthPass || isLoading}
                  >
                    재전송
                  </Button>
                ) : (
                  <Button
                    disabled={isLoading}
                    size="large"
                    type="primary"
                    ghost
                    onClick={
                      dataForm.managerPhone.trim().length === 0 ||
                      !validatePhone(dataForm.managerPhone)
                        ? () => {
                            setStatus({
                              ...status,
                              managerPhone: {
                                status: "error",
                                explain: ALERT_MESSAGE.WRONG_PHONE,
                              },
                            });
                          }
                        : debouncedPhoneSend
                    }
                  >
                    인증번호 전송
                  </Button>
                )
              }
              onChange={(e) => {
                const isPass = validatePhone(e);
                if (e !== "")
                  setStatus({
                    ...status,
                    managerPhone: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_PHONE,
                    },
                  });
                setAuthPass(false);
                setDataForm({ ...dataForm, managerPhone: e });
              }}
            />
            <Explain
              status="question"
              explain="휴대폰 번호로 심사 결과를 알려드립니다."
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>인증번호</FormLabel>
            <AuthTokenInput
              counter={counter}
              minuteText={minuteText}
              secondText={secondText}
              isPhoneSended={dataForm.authTokenId === ""}
              isAuthPassed={isAuthPass}
              stopCounter={stopCounter}
              onVerifyAuth={() => {
                checkPhoneAuthMutation.mutate({
                  key: dataForm.managerPhone,
                  authTokenId: dataForm.authTokenId,
                  token: authCode,
                });
              }}
              disabled={isAuthPass}
              onChangeAuth={(e) => setAuthcode(e)}
              authNumValue={authCode}
            />
            {status.auth && (
              <Explain
                explain={status.auth.explain}
                status={status.auth.status}
              />
            )}
          </HalfCol>
          <HalfCol>
            <FormLabel notRequired>예비번호1</FormLabel>
            <TextInputs
              isNotBordered
              showCount={false}
              ref={(ref) => {
                inputRef.current.subPhone1 = ref;
              }}
              value={dataForm.subPhone1}
              placeholder={PLACEHOLDER.phone}
              status={status.subPhone1.status}
              explain={status.subPhone1.explain}
              maxLength={20}
              onChange={(e) => {
                const isPass = validatePhone(e);
                if (e)
                  setStatus({
                    ...status,
                    subPhone1: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_PHONE,
                    },
                  });
                if (!e)
                  setStatus({
                    ...status,
                    subPhone1: {
                      status: undefined,
                      explain: undefined,
                    },
                  });
                setDataForm({ ...dataForm, subPhone1: e });
              }}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel notRequired> 예비번호2</FormLabel>
            <TextInputs
              isNotBordered
              showCount={false}
              ref={(ref) => {
                inputRef.current.subPhone2 = ref;
              }}
              value={dataForm.subPhone2}
              placeholder={PLACEHOLDER.phone}
              status={status.subPhone2.status}
              explain={status.subPhone2.explain}
              maxLength={20}
              onChange={(e) => {
                const isPass = validatePhone(e);
                if (e)
                  setStatus({
                    ...status,
                    subPhone2: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_PHONE,
                    },
                  });
                if (!e)
                  setStatus({
                    ...status,
                    subPhone2: {
                      status: undefined,
                      explain: undefined,
                    },
                  });
                setDataForm({ ...dataForm, subPhone2: e });
              }}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>이메일 주소</FormLabel>
            <TextInputs
              isNotBordered
              ref={(ref) => {
                inputRef.current.managerEmail = ref;
              }}
              status={status.managerEmail.status}
              explain={status.managerEmail.explain}
              placeholder={PLACEHOLDER.email}
              value={dataForm.managerEmail}
              onChange={(e) => {
                const isPass = validateEmail(e);
                setDataForm({ ...dataForm, managerEmail: e });
                if (e !== "")
                  setStatus({
                    ...status,
                    managerEmail: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_EMAIL,
                    },
                  });
              }}
              maxLength={100}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>매장 대표번호</FormLabel>
            <TextInputs
              isNotBordered
              ref={(ref) => {
                inputRef.current.tel = ref;
              }}
              placeholder={PLACEHOLDER.phone}
              status={status.tel.status}
              explain={status.tel.explain}
              value={dataForm.tel}
              onChange={(e) => {
                const isPass = /^[0-9]{2,3}[0-9]{3,4}[0-9]{4}/.test(e);
                e = e.replaceAll("-", "");
                setDataForm({ ...dataForm, tel: e });
                if (e !== "")
                  setStatus({
                    ...status,
                    tel: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.NEED_NUMBER,
                    },
                  });
              }}
              maxLength={11}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>사업자등록번호</FormLabel>
            <TextInputs
              isNotBordered
              ref={(ref) => {
                inputRef.current.businessRegistrationNumber = ref;
              }}
              placeholder={PLACEHOLDER.businessRegistrationNumber}
              status={status.businessRegistrationNumber.status}
              explain={status.businessRegistrationNumber.explain}
              value={dataForm.businessRegistrationNumber}
              onChange={(e) => {
                const isPass = /([0-9]{3})-?([0-9]{2})-?([0-9]{5})/.test(e);
                e.replaceAll("-", "");
                setDataForm({ ...dataForm, businessRegistrationNumber: e });
                if (e !== "")
                  setStatus({
                    ...status,
                    businessRegistrationNumber: {
                      status: isPass ? undefined : "error",
                      explain: isPass
                        ? undefined
                        : ALERT_MESSAGE.WRONG_BUSI_NUMBER,
                    },
                  });
              }}
              maxLength={10}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel notRequired>사업자 등록증 상호명</FormLabel>
            <TextInputs
              isNotBordered
              status={status.repairShopName.status}
              explain={status.repairShopName.explain}
              placeholder={PLACEHOLDER.name}
              value={dataForm.repairShopName}
              maxLength={100}
              onChange={(e) => {
                setStatus({ ...status, repairShopName: initialValidation });
                setDataForm({ ...dataForm, repairShopName: e });
              }}
            />
          </HalfCol>
          <FullCol
            ref={(ref) => {
              divRef.current.businessMediaId = ref;
            }}
          >
            <FormLabel>사업자 등록증</FormLabel>

            <ImageTextUploader
              folder="tirepick_repairshop_web_business_img/"
              max={1}
              onUpload={(e: Media[]) => {
                if (e) {
                  if (e.length > 0) {
                    if (e[0].id) {
                      setDataForm({ ...dataForm, businessMediaId: e[0].id });
                      setStatus({
                        ...status,
                        businessMediaId: {
                          status: undefined,
                          explain: undefined,
                        },
                      });
                    } else setDataForm({ ...dataForm, businessMediaId: -1 });
                  } else setDataForm({ ...dataForm, businessMediaId: -1 });
                } else setDataForm({ ...dataForm, businessMediaId: -1 });
              }}
              onRemove={() => {
                setDataForm({ ...dataForm, businessMediaId: -1 });
              }}
              errorExplain={status.businessMediaId.explain}
              inputKey="businessMedia"
            />

            <Explain
              status="question"
              explain="첨부파일은 최대 3MB, 1개 까지 사진파일 형식만 가능합니다. (JPG, PNG, GIF)"
            />
          </FullCol>

          <FullCol>
            <FormLabel>매장 주소</FormLabel>
            <TextInputs
              value={dataForm.street}
              ref={(ref) => {
                inputRef.current.street = ref;
              }}
              onClick={() => {
                setStatus({
                  ...status,
                  street: initialValidation,
                  detail: initialValidation,
                });

                openModal(
                  <SearchAddress
                    setAddress={(e: any) => {
                      setDataForm({ ...dataForm, ...e });
                    }}
                    setShowSearchAddress={() => {
                      closeModal();
                    }}
                  />
                );
              }}
              placeholder={PLACEHOLDER.address}
              isNotBordered
              status={status.street.status}
              explain={status.street.explain}
              onChange={() => {}}
              disabled
              additionalBtn={
                <Button
                  size="large"
                  type="primary"
                  ghost
                  disabled={getLoading()}
                  onClick={() => {
                    setStatus({
                      ...status,
                      street: initialValidation,
                      detail: initialValidation,
                    });
                    openModal(
                      <SearchAddress
                        setAddress={(e: any) =>
                          setDataForm({ ...dataForm, ...e })
                        }
                        setShowSearchAddress={closeModal}
                      />
                    );
                  }}
                >
                  주소 찾기
                </Button>
              }
            />
            <TextInputs
              placeholder={PLACEHOLDER.detailAddress}
              isNotBordered
              ref={(ref) => {
                inputRef.current.street = ref;
              }}
              status={status.detail.status}
              explain={status.detail.explain}
              value={dataForm.detail}
              onChange={(e) => {
                setDataForm({ ...dataForm, detail: e });
                setStatus({
                  ...status,
                  street: initialValidation,
                  detail: initialValidation,
                });
              }}
              maxLength={50}
            />
          </FullCol>

          <FullCol>
            <FormTitle>예약 정보</FormTitle>
          </FullCol>
          <FullCol>
            <FormLabel>평일 하루 최대 몇개까지 예약이 가능하신가요?</FormLabel>
            <CustomInputNumber
              min={0}
              maxLength={100}
              value={dataForm.maximumWeekdayVehicleCount}
              onChange={(e) => {
                setDataForm({
                  ...dataForm,
                  maximumWeekdayVehicleCount: Number(e),
                });
              }}
            />
          </FullCol>
          <FullCol>
            <FormLabel>
              주말(공휴일) 하루 최대 몇대까지 예약 가능하신가요?
            </FormLabel>
            <CustomInputNumber
              min={0}
              maxLength={100}
              value={dataForm.maximumWeekendVehicleCount}
              onChange={(e) => {
                setDataForm({
                  ...dataForm,
                  maximumWeekendVehicleCount: Number(e),
                });
              }}
            />
          </FullCol>
          <FullCol>
            <FormTitle>매장 환경</FormTitle>
          </FullCol>
          <HalfCol>
            <FormLabel>보유 리프트</FormLabel>
            <SelectGroup
              placeholder={PLACEHOLDER.select}
              selectArray={NumberArray(10)}
              status={status.liftCount.status}
              explain={status.liftCount.explain}
              onChange={(e) =>
                setDataForm({ ...dataForm, liftCount: Number(e) })
              }
              value={dataForm.liftCount}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>보유 정비인력(명)</FormLabel>
            <SelectGroup
              placeholder={PLACEHOLDER.select}
              selectArray={NumberArray(10)}
              status={status.employeeCount.status}
              explain={status.employeeCount.explain}
              onChange={(e) =>
                setDataForm({ ...dataForm, employeeCount: Number(e) })
              }
              value={dataForm.employeeCount}
            />
          </HalfCol>
          <FullCol>
            <FormLabel>고객 대기실 보유 여부</FormLabel>
            <RadioGroup
              options={yesOrNoArray}
              onChange={(e) => {
                setDataForm({
                  ...dataForm,
                  waitingRoomExistence: e.target.value,
                });
              }}
              value={dataForm.waitingRoomExistence}
            />
          </FullCol>
          <FullCol
            ref={(ref) => {
              divRef.current.allMedia = ref;
            }}
          >
            <FormLabel>매장 전체 사진</FormLabel>
            <PreviewUploader
              inputKey="repairShopMedias_all"
              folder="repairShop_web_medias"
              onUpload={(e) => {
                setStatus({ ...status, allMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  allMedia: e[0],
                });
              }}
              onRemove={() => {
                setStatus({ ...status, allMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  allMedia: undefined,
                });
              }}
              max={1}
              imageList={dataForm.allMedia ? [dataForm.allMedia] : []}
            />

            <Row gutter={[0, 8]} style={{ marginTop: "8px" }} align="top">
              {status.allMedia?.explain && (
                <FullCol>
                  <ImageExplainWrapper style={{ marginTop: "-10px" }}>
                    <Explain
                      status={status.allMedia.status}
                      explain={status.allMedia.explain}
                    />
                  </ImageExplainWrapper>
                </FullCol>
              )}
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <Number1 fill={theme.colors.gray1} />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장-전체 (입점 매장의 경우 건물의 전체 모습이 보이도록 촬영
                    바랍니다.)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <Number1 fill={theme.colors.gray1} />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장 소개 페이지에서 대표 사진으로 설정됩니다.
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <CautionBlank />
                  </IconWrapper>
                  <ImageExplainSpan>
                    첨부파일은 최대 3MB 사진파일 형식만 가능합니다. (JPG, PNG,
                    GIF)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
            </Row>
          </FullCol>
          <FullCol
            ref={(ref) => {
              divRef.current.frontMedia = ref;
            }}
          >
            <FormLabel>매장 정면 사진</FormLabel>
            <PreviewUploader
              inputKey="repairShopMedias_front"
              folder="repairShop_web_medias"
              onUpload={(e) => {
                setStatus({ ...status, frontMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  frontMedia: e[0],
                });
              }}
              onRemove={() => {
                setStatus({ ...status, frontMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  frontMedia: undefined,
                });
              }}
              max={1}
              imageList={dataForm.frontMedia ? [dataForm.frontMedia] : []}
            />

            <Row gutter={[0, 8]} style={{ marginTop: "8px" }} align="top">
              {status.frontMedia?.explain && (
                <FullCol>
                  <ImageExplainWrapper style={{ marginTop: "-10px" }}>
                    <Explain
                      status={status.frontMedia.status}
                      explain={status.frontMedia.explain}
                    />
                  </ImageExplainWrapper>
                </FullCol>
              )}

              <FullCol>
                <ImageExplainWrapper>
                  {" "}
                  <IconWrapper>
                    <Number2 />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장-정면 (간판 및 리프트 수를 확인할 수 있도록 촬영
                    바랍니다.)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>

              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <CautionBlank />
                  </IconWrapper>
                  <ImageExplainSpan>
                    첨부파일은 최대 3MB 사진파일 형식만 가능합니다. (JPG, PNG,
                    GIF)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
            </Row>
          </FullCol>
          <FullCol
            ref={(ref) => {
              divRef.current.inMedia = ref;
            }}
          >
            <FormLabel>매장 내부 사진</FormLabel>
            <PreviewUploader
              inputKey="repairShopMedias_in"
              folder="repairShop_web_medias"
              onUpload={(e) => {
                setStatus({ ...status, inMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  inMedia: e[0],
                });
              }}
              onRemove={() => {
                setStatus({ ...status, inMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  inMedia: undefined,
                });
              }}
              max={1}
              imageList={dataForm.inMedia ? [dataForm.inMedia] : []}
            />

            <Row gutter={[0, 8]} style={{ marginTop: "8px" }} align="top">
              {status.inMedia?.explain && (
                <FullCol>
                  <ImageExplainWrapper style={{ marginTop: "-10px" }}>
                    <Explain
                      status={status.inMedia.status}
                      explain={status.inMedia.explain}
                    />
                  </ImageExplainWrapper>
                </FullCol>
              )}

              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <Number3 />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장-내부 (고객 대기 공간이 보이도록 촬영 바랍니다.)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <CautionBlank />
                  </IconWrapper>
                  <ImageExplainSpan>
                    첨부파일은 최대 3MB 사진파일 형식만 가능합니다. (JPG, PNG,
                    GIF)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
            </Row>
          </FullCol>
          <FullCol>
            <FormTitle>정비 가능 항목</FormTitle>
          </FullCol>
          <FullCol>
            <CustomForm
              form={form}
              onFinish={handleFinish}
              validateMessages={{
                required: "필수 값입니다.",
              }}
              initialValues={{
                repairShopOption: {
                  options: {
                    services: {
                      tire: {
                        minInch: 19,
                        maxInch: 22,
                      },
                    },
                  },
                },
                tireSize: [19, 22],
              }}
              scrollToFirstError={{ behavior: "smooth", block: "center" }}
            >
              <UserInfoServiceForm form={form} />
            </CustomForm>
          </FullCol>
          <FullCol>
            <FormTitle>추가사항</FormTitle>
          </FullCol>
          <FullCol>
            <FormLabel notRequired>참고 및 요청사항</FormLabel>
            <TextArea
              placeholder={PLACEHOLDER.moreDetail || ""}
              value={dataForm.moreDetail}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  moreDetail:
                    e.target.value === "" ? undefined : e.target.value,
                })
              }
              maxWidth="100%"
              maxLength={100}
            />
          </FullCol>
          <FullCol>
            <FormLabel notRequired>매장 한마디</FormLabel>
            <TextArea
              placeholder={PLACEHOLDER.introduction}
              value={dataForm.introduction || ""}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  introduction:
                    e.target.value === "" ? undefined : e.target.value,
                })
              }
              maxWidth="100%"
              maxLength={100}
            />
          </FullCol>
          <FullCol>
            <FormLabel>개인정보 수집 및 이용동의</FormLabel>
            <StyledTable
              pagination={false}
              style={{ width: "100%" }}
              columns={[
                {
                  dataIndex: "type",
                  title: "구분",
                  key: 1,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
                {
                  dataIndex: "items",
                  title: "수집 항목",
                  key: 2,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
                {
                  dataIndex: "purpose",
                  title: "이용목적",
                  key: 3,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
                {
                  dataIndex: "saveDate",
                  title: "보유기간",
                  key: 4,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
              ]}
              scroll={{ x: 700 }}
              dataSource={[
                {
                  key: 1,
                  type: "필수",
                  items: "이름,휴대폰번호,이메일",
                  purpose: "제휴 신청",
                  saveDate: "신청일로부터 1개월",
                },
              ]}
            />
            <Explain
              status="caution"
              explain="고객님께서는 동의를 거부할 권리가 있으나, 미 동의 시 해당 서비스를 이용할 수 없습니다."
            />
          </FullCol>
          <FullCol>
            <StyledDiv>
              <CheckBox
                value={[
                  dataForm.marketingEmailReceivable &&
                    dataForm.marketingMessageReceivable &&
                    dataForm.marketingPushReceivable,
                ]}
                onChange={onCheckMarketing}
                options={marketingPossibleArray}
              />
            </StyledDiv>
          </FullCol>
          <FullCol>
            <InputsContainer>
              <BtnWrapper>
                <ButtonWrapper>
                  <Buttons
                    size="block"
                    isSecondary
                    text="취소"
                    onClick={() => {
                      openConfirmModal({
                        contents: "작성하신 내용이 취소됩니다.",
                        title: "취소하기",
                        onOk: () => {
                          nav(PATH.LOGIN);
                          closeModal();
                        },
                      });
                    }}
                  />
                </ButtonWrapper>

                <ButtonWrapper>
                  <Buttons
                    size="block"
                    disabled={!dataForm.marketingEmailReceivable}
                    text="신청"
                    onClick={() => form.submit()}
                    // onClick={onClickSendRegister}
                  />
                </ButtonWrapper>
              </BtnWrapper>
            </InputsContainer>
          </FullCol>
        </Row>
      </FormWrapper>
    </FormContatiner>
  );
};

export default RegisterForm;

const HalfCol = forwardRef<HTMLDivElement, { children?: any }>((props, ref) => (
  <InputWrapper ref={ref} {...colHalfProps}>
    {props.children}
  </InputWrapper>
));
const FullCol = forwardRef<HTMLDivElement, { children?: any }>((props, ref) => (
  <InputWrapper ref={ref} {...colFullProps}>
    {props.children}
  </InputWrapper>
));

const FormContatiner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  overflow: hidden;
  overflow-y: auto;
`;
const FormWrapper = styled.div`
  max-width: 700px;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    margin-top: 24px;
  }
`;
const InputWrapper = styled(Col)`
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 360px;

    justify-content: center;
    align-items: center;
    align-content: center;
  }
`;
const FormTitle = styled.span`
  ${theme.typo.title.t32};
  margin-top: 120px;
`;
const BtnWrapper = styled.form`
  display: flex;
  max-width: 400px;
  justify-content: space-between;
  margin-top: 120px;
  margin-bottom: 200px;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 320px;
    justify-content: space-between;
  }
`;
const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const RegisterTitle = styled.span`
  ${theme.typo.title.t32};
  margin-top: 40px;
`;
const ButtonWrapper = styled.div`
  width: 192px;
  height: 54px;
  margin: 8px;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    width: 156px;
    margin: 4px;
  }
`;
const InputsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const ImageExplainSpan = styled.span`
  ${theme.typo.body.r14};
  line-height: 18px;
  margin-left: 6px;
`;
const ImageExplainWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
`;
const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
`;
const StyledTable = styled(Table)`
  && tbody > tr > td {
    background-color: white;
  }
  .noHover {
    background-color: white;
  }
`;
